module.exports = __webpack_public_path__ + "img/ventas.8a6527b3.svg";